import type { CatalogRatioGroupData } from '@gql/graphql';
import { type CatalogRatioDataForList, RatioTypeEnum } from '@gql/graphql';

import { useMemo } from 'react';

type TUseMassApplicationTableData = {
    responseRatioType?: RatioTypeEnum;
    selectedRatioGroup: CatalogRatioGroupData | null;
    responseRatioGroupId?: string | number;
    ratiosData: CatalogRatioDataForList[];
};

export const useMassApplicationRatiosOutputData = ({
    responseRatioType,
    ratiosData,
    responseRatioGroupId,
    selectedRatioGroup,
}: TUseMassApplicationTableData) => {
    const selectedRatioGroupId = selectedRatioGroup?.id;

    const currentRatiosRowData = useMemo(() => {
        if (
            !responseRatioType ||
            (responseRatioType !== RatioTypeEnum.TechPartCoef && (!responseRatioGroupId || !selectedRatioGroupId)) ||
            !Array.isArray(ratiosData)
        ) {
            return [];
        }

        return ratiosData;
    }, [responseRatioType, ratiosData, responseRatioGroupId, selectedRatioGroupId]);

    return useMemo(() => ({ currentRatiosRowData }), [currentRatiosRowData]);
};
